import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Box, Grid, IconButton, Typography } from "@material-ui/core";
import { Check, ClearOutlined, Close, Translate } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core";
import { LanguageContext } from "../containers/languageprovider";
import { Tabs } from "@material-ui/core";
import { Tab } from "@material-ui/core";
import { returnStringTranslation } from "./printLanguageSelect";
import { Carousel } from "react-responsive-carousel";
import Iframe from "react-iframe";
import {
  GoogleMap,
  Marker,
  StreetViewPanorama,
} from "@react-google-maps/api";

const useStyles = makeStyles((theme) => ({
  tabs: {
    "& .MuiTabs-indicator": {
      // display: "none",
      height: "3px",
      width: "auto",
    },
  },
  paper: {
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0)",
  },
  ArrowsCarousel: {
    width: "50px",
    height: "50px",
    position: "absolute",
    zIndex: 2,
    top: "calc(50% - 25px)",
    cursor: "pointer",
  },
  boxSlider: {
    // paddingTop: 10,
    // paddingLeft: 10,
    display: "flex",
    // // width: "50%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    margin: "25px",
    [theme.breakpoints.down("sm")]: {
      margin: "0",
    },
    // flexGrow: 1,
    // flexBasis: 0,
    // margin: 10,
  },
  imgSlider: {
    width: "100%",
    height: "80vh",
    objectFit: "contain",
    // backgroundRepeat: "no-repeat",
    // margin: "auto",
    // margin: 10,
    // borderRadius: 20,
  },
}));

export default function BuildingMediaModal(props) {
  const {
    open,
    setOpen,
    onCancel,
    images,
    MobileScreen,
    userLanguage,
    buildingedit,
    value,
    setValue,
  } = props;
  const classes = useStyles();
  const { dictionary } = React.useContext(LanguageContext);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const handleClose = () => {
    setOpen(false);
    onCancel?.();
  };

  const containerStyle = {
    width: "100%",
    height: MobileScreen ? "98%" : "99%",
    zIndex: 999,
  };

  const [selectedCenter, setSelectedCenter] = React.useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -(height / 2),
  });

  return (
    <Dialog
      fullScreen
      fullWidth
      classes={{ paper: classes.paper }}
      open={open}
      onClose={handleClose}
      aria-labelledby="draggable-dialog-title"
    >
      <Box style={{ overflow: "hidden", height: "100vh" }}>
        <Grid
          container
          alignItems="center"
          justifyContent={MobileScreen && "space-between"}
          style={{
            width: "100%",
            minHeight: "75px",
            height: "8%",
            background: "rgba(0, 0, 0, .4)",
            color: "white",
            position: "relative",
            // padding: MobileScreen ? "12px" : "20px",
            borderBottom: "1px solid white",
          }}
        >
          <Grid
            style={{
              paddingLeft: !MobileScreen ? "20px" : "10px",
              fontSize: MobileScreen ? "14px" : "24px",
              display: MobileScreen ? "inline" : "block",
              position: MobileScreen && "absolute",
              top: 8,
              left: 6,
            }}
            item
            xs={0}
            md={3}
          >
            {value === "gallery" && (
              <>
                {currentIndex + 1} / {images.length}
              </>
            )}
          </Grid>
          <Grid
            style={{
              height: "100%",
              textTransform: "uppercase",
              paddingTop: "16px",
              paddingLeft: MobileScreen && "5px",
            }}
            container
            justifyContent="center"
            // spacing={2}
            item
            xs={12}
            md={6}
          >
            <Tabs
              TabIndicatorProps={{
                style: {
                  background: "#fff",
                },
              }}
              className={classes.tabs}
              // textColor="pink"
              // indicatorColor="pink"
              value={value}
              onChange={handleChange}
            >
              {images.length > 0 && (
                <Tab
                  style={{
                    fontSize: MobileScreen ? "12px" : "18px",
                    minWidth: 0,
                    width: MobileScreen ? "55px" : "80px",
                    marginRight: 10,
                  }}
                  value="gallery"
                  label="GALLERY"
                />
              )}
              {buildingedit.virtual_tour !== null &&
                buildingedit.virtual_tour !== "" &&
                buildingedit.virtual_tour !== undefined && (
                  <Tab
                    style={{
                      fontSize: MobileScreen ? "12px" : "18px",
                      minWidth: 0,
                      marginRight: 10,
                    }}
                    value="virtual_view"
                    label="VIRTUAL VIEW"
                  />
                )}
              {buildingedit.video !== null &&
                buildingedit.video !== "" &&
                buildingedit.video !== undefined && (
                  <Tab
                    style={{
                      fontSize: MobileScreen ? "12px" : "18px",
                      minWidth: 0,
                      marginRight: 10,
                    }}
                    value="video"
                    label="VIDEO"
                  />
                )}
              <Tab
                style={{
                  fontSize: MobileScreen ? "12px" : "18px",
                  minWidth: 0,
                  marginRight: 10,
                }}
                value="map"
                label="MAP"
              />
              <Tab
                style={{
                  fontSize: MobileScreen ? "12px" : "18px",
                  minWidth: 0,
                  marginRight: 10,
                }}
                value="street_view"
                label="STREET VIEW"
              />
            </Tabs>
          </Grid>
          <Grid
            container
            style={{
              position: MobileScreen && "absolute",
              top: 5,
              right: MobileScreen && 5,
              paddingRight: !MobileScreen ? "20px" : "10px",
              display: "inline-flex",
            }}
            justifyContent="flex-end"
            item
            xs={1}
            md={3}
          >
            <Grid item>
              <Close
                style={{ cursor: "pointer" }}
                onClick={() => setOpen(false)}
                color="white"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          style={{
            width: "100%",

            backgroundColor: "rgba(0, 0, 0, .8)",
            height: "92%",
            color: "white",
            overflow: "hidden",
          }}
          justifyContent="center"
          container
        >
          {value === "gallery" && (
            <Grid item container>
              <Carousel
                centerMode={true}
                centerSlidePercentage={100}
                showIndicators={false}
                showThumbs={false}
                autoPlay={false}
                swipeable={true}
                dynamicHeight={true}
                infiniteLoop={true}
                showStatus={false}
                onChange={(selectedIndex) => setCurrentIndex(selectedIndex)}
                renderArrowPrev={(onClickHandler, hasPrev, label) =>
                  hasPrev && (
                    <div
                      className={classes.ArrowsCarousel}
                      onClick={onClickHandler}
                      style={{ left: 15 }}
                    >
                      <img
                        src="/images/ico/LeftArrowCarousel.svg"
                        height={50}
                      />
                    </div>
                  )
                }
                renderArrowNext={(onClickHandler, hasNext, label) =>
                  hasNext && (
                    <div
                      className={classes.ArrowsCarousel}
                      onClick={onClickHandler}
                      style={{
                        right: 15,
                      }}
                    >
                      <img
                        src="/images/ico/RightArrowCarousel.svg"
                        height={50}
                      />
                    </div>
                  )
                }
              >
                {images.map((item, index) => (
                  <div className={classes.boxSlider}>
                    <img
                      key={index}
                      className={classes.imgSlider}
                      alt={returnStringTranslation(
                        item.description,
                        userLanguage
                      )}
                      src={item.image}
                    />
                  </div>
                ))}
              </Carousel>
            </Grid>
          )}
          {value === "virtual_view" && (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{
                height: MobileScreen ? "98%" : "100%",
                overflow: "hidden",
              }}
              item
            >
              {buildingedit.virtual_tour !== null &&
                buildingedit.virtual_tour !== "" &&
                buildingedit.virtual_tour !== undefined && (
                  <Iframe
                    sandbox={["allow-scripts","allow-same-origin"]}
                    url={buildingedit.virtual_tour}
                    width="100%"
                    height="100%"
                    allowFullScreen
                    frameBorder={0}
                    display="initial"
                    position="relative"
                  />
                )}
            </Grid>
          )}
          {value === "video" && (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{
                height: MobileScreen ? "98%" : "100%",
                overflow: "hidden",
              }}
              item
            >
              {buildingedit.video !== null &&
                buildingedit.video !== "" &&
                buildingedit.video !== undefined && (
                  <Iframe
                    url={buildingedit.video}
                    width="100%"
                    height="100%"
                    // allowFullScreen
                    frameBorder={0}
                    display="initial"
                    position="relative"
                  />
                )}
            </Grid>
          )}{" "}
          {value === "map" && (
            <GoogleMap
              mapTypeId="roadmap"
              onLoad={(map) => {
                map.setZoom(15);
                map.setCenter({
                  lat: buildingedit.lat,
                  lng: buildingedit.lng,
                });
                // map.setMapTypeId("SATELLITE");
              }}
              options={{
                styles: [
                  {
                    featureType: "poi",
                    stylers: [{ visibility: "off" }],
                  },
                  {
                    featureType: "administrative",
                    stylers: [{ visibility: "off" }],
                  },
                ],
                // mapTypeId: "satellite",
              }}
              mapContainerStyle={containerStyle}
            >
              <Marker
                position={{
                  lat: buildingedit.lat,
                  lng: buildingedit.lng,
                }}
                onClick={() => {
                  setSelectedCenter(buildingedit);
                }}
              >
                {/* {selectedCenter && (
                  <InfoWindow
                    onCloseClick={() => {
                      setSelectedCenter(null);
                    }}
                    position={{
                      lat: selectedCenter.latitude,
                      lng: selectedCenter.longitude,
                    }}
                  >

                  </InfoWindow>
                )} */}
              </Marker>
            </GoogleMap>
          )}
          {value === "street_view" && (
            // <div
            //   style={{
            //     position: "relative",
            //     height: MobileScreen ? "99vh" : "100vh",
            //     overflow: "hidden",
            //   }}
            // >
            <GoogleMap
              id="circle-example"
              mapContainerStyle={containerStyle}
              zoom={7}
              center={{
                lat: buildingedit.lat,
                lng: buildingedit.lng,
              }}
            >
              <StreetViewPanorama
                position={{
                  lat: buildingedit.lat,
                  lng: buildingedit.lng,
                }}
                visible={true}
              />
            </GoogleMap>
            // </div>
            // <GoogleMap
            //   mapTypeId="roadmap"
            //   onLoad={(map) => {
            //     map.setZoom(15);
            //     map.setCenter({
            //       lat: buildingedit.lat,
            //       lng: buildingedit.lng,
            //     });
            //     // map.setMapTypeId("SATELLITE");
            //   }}
            //   options={{
            //     styles: [
            //       {
            //         featureType: "poi",
            //         stylers: [{ visibility: "off" }],
            //       },
            //       {
            //         featureType: "administrative",
            //         stylers: [{ visibility: "off" }],
            //       },
            //     ],
            //     mapTypeId: "satellite",
            //   }}
            //   mapContainerStyle={containerStyle}
            // >
            //   <Marker
            //     position={{
            //       lat: buildingedit.lat,
            //       lng: buildingedit.lng,
            //     }}
            //     onClick={() => {
            //       setSelectedCenter(buildingedit);
            //     }}
            //   ></Marker>
            // </GoogleMap>
          )}
        </Grid>

        <DialogActions></DialogActions>
      </Box>
    </Dialog>
  );
}
